import tableCloumnFilter from './table-column-filter.vue'
import Vue from 'vue'

let filterInstanceCollection = {}

const addIcon = function (tableInstance, filterInstance) {
  if(!tableInstance) return

  const iconWrapper = document.createElement('div')
  iconWrapper.className = 'table-column-filter'
  const icon = document.createElement('i')
  icon.className = 'el-icon-setting table-column-filter__icon'

  icon.addEventListener('click', function (e) {
    e.stopPropagation()

    const documentEl = document.documentElement
    const body = document.body
    const scrollLeft = Math.max(documentEl.scrollLeft, body.scrollLeft)
    const scrollTop = Math.max(documentEl.scrollTop, body.scrollTop)

    filterInstance.$refs.dropDown.isShow ? filterInstance.hide() : filterInstance.show({
      left: e.clientX + scrollLeft,
      top: e.clientY + scrollTop
    })
  }, false)

  setTimeout(() => {
    iconWrapper.style.height = tableInstance.$refs.headerWrapper.clientHeight - 1 + 'px'
    iconWrapper.appendChild(icon)
    tableInstance.$el.appendChild(iconWrapper)
  }, 20)

  return iconWrapper
}

tableCloumnFilter.newInstance = function ({tableId, tableInstance, filterChangeCb, filterData}) {
  let filterInstance, iconWrapper

  if(!filterInstanceCollection[tableId]) {
    const div = document.createElement('div')
    document.body.appendChild(div)

    const instance = new Vue({
      el: div,
      data: filterData,
      render: h => h(
        tableCloumnFilter,
        {
          props: filterData,
          on: {
            filterChange: filterChangeCb
          }
        }
      )
    })

    filterInstance = instance.$children[0]
    filterInstanceCollection[tableId] = filterInstance
  }else{
    filterInstance = filterInstanceCollection[tableId]
  }

  iconWrapper = addIcon(tableInstance, filterInstance)

  return {
    update () {
      setTimeout(() => {
        iconWrapper.style.height = tableInstance.$refs.headerWrapper.clientHeight - 1 + 'px'
      }, 20)
    }
  }
}

export default tableCloumnFilter
